
import { defineComponent } from "vue";
import { VDialog } from "vuetify/lib";

export default defineComponent({
  mixins: [VDialog],
  props: {
    overlayOpacity: {
      type: [Number, String],
      default: "0.16",
    },
  },
});
